import './projects.less'

import {action, m, StatelessView} from '@codeurs/front'
import {Project} from 'types'
import Layout from 'views/layout'
import {
	Card,
	CardContent,
	CardFooter,
	CardImage,
	CardLink,
	CardTitle
} from 'views/layout/card'
import {CollectionTitle} from 'views/layout/collectiontitle'
import ContentContainer from 'views/layout/contentcontainer'
import Wysiwyg from 'views/layout/wysiwyg'

const ProjectsItem: StatelessView<Project> = ({
	title,
	description,
	website,
	email,
	intro_image
}) =>
	m(Card,
		m(CardImage, intro_image),
		m(CardContent, [
			m(CardTitle, title),
			m(Wysiwyg, {html: description}),
			m(CardFooter, [
				website && m(CardLink, action(website), 'Project website'),
				email && m(CardLink, action(email), 'Project contact')
			])
		])
	)

export class Projects extends Layout<{
	projects: Array<Project>
}> {
	view() {
		const {projects} = this.attrs.data
		const {current, past} = projects.reduce(
			(acc, project) => {
				const collection = project.archived ? acc.past : acc.current
				collection.push(project)
				return acc
			},
			{current: [], past: []}
		)
		return m('.projects',
			m(ContentContainer, [
				current.length > 0 && [
					m(CollectionTitle, 'Current projects'),
					current.map(project => m(ProjectsItem, project))
				],
				past.length > 0 && [
					m(CollectionTitle, 'Past projects'),
					past.map(project => m(ProjectsItem, project))
				]
			])
		)
	}
}
